import { GCPVMInstanceType } from "common";
import { StatusFilterValue } from "@via/pages/workbenchs/components/workbench-filter-bar.tsx";

/**
 * Creates a backend filter query string from frontend filter state
 * Format: field:operator=value,field:operator=value
 */
export const createWorkbenchFilterQuery = (filters: {
  instanceType: GCPVMInstanceType | null;
  owner: string | null;
  statuses: StatusFilterValue[];
  search?: string;
}): string | undefined => {
  const filterParts: string[] = [];

  // Instance Type filter
  if (filters.instanceType) {
    filterParts.push(`instanceType:eq=${filters.instanceType}`);
  }

  // Owner filter
  if (filters.owner) {
    filterParts.push(`owner:eq=${filters.owner}`);
  }

  // Search filter (matches workbench or name)
  if (filters.search && filters.search.trim().length > 0) {
    filterParts.push(`search:like=${filters.search.trim()}`);
  }

  // Status filters
  // Map frontend status values to backend appState values
  // Based on VMAppState enum: Running, Stopped, Terminated
  if (filters.statuses.length > 0) {
    const statusValues: string[] = [];

    filters.statuses.forEach(status => {
      switch (status) {
        case "running":
          // Running means appState = Running (VMAppState.Running)
          statusValues.push("Running");
          break;
        case "stopped":
          // Stopped means appState = Stopped (VMAppState.Stopped)
          statusValues.push("Stopped");
          break;
        case "terminated":
          // Terminated means appState = Terminated (VMAppState.Terminated)
          statusValues.push("Terminated");
          break;
      }
    });

    // Use "in" operator for multiple statuses, "eq" for single status
    if (statusValues.length === 1) {
      filterParts.push(`appState:eq=${statusValues[0]}`);
    } else if (statusValues.length > 1) {
      // Use "in" operator with semicolon-separated values
      filterParts.push(`appState:in=${statusValues.join(";")}`);
    }
  }

  return filterParts.length > 0 ? filterParts.join(",") : undefined;
};
